import { careersZh } from './careers-zh'

export default {
  ...careersZh,
  nav: {
    home: '主页',
    about: '关于我们',
    rd: '研发',
    innovation: '创新研发',
    pipelineStrategy: '产品管线与发展战略',
    science: '科学研发',
    expandedAccess: '同情用药政策',
    pipeline: '产品管线',
    disease: '研究领域',
    strategy: '发展战略',
    news: '新闻动态',
    careers: '招贤纳士',
    detail: '职位详情',
    contact: '联系我们',
    ir: '投资者关系',
    annoucement: '公告及通知',
    irContact: 'IR联系方式',
    governance: '公司治理',
    stock: '股票信息'
  },
  ir: {
    AoA: '公司章程',
    interim: '临时公告',
    periodic: '定期公告'
  },
  ir_contact: {
    name: '投资者关系',
    addr: '上海市浦东新区亮景路199号, 201203',
    tel: '+86-21-61095757',
    email: 'IR@dizalpharma.com'
  },
  core_value: {
    name: '核心价值',
    value1: '全球创新',
    value2: '学思笃行',
    value3: '志在必得',
    aim: '我们致力于解决未满足的医疗需求'
  },
  about: {
    our_story: '我们的故事',
    about_us: '关于我们',
    about_dizal: '关于迪哲',
    about_1:
      '迪哲医药（股票代码：688192）是一家创新型生物医药企业，专注于恶性肿瘤、免疫性疾病领域创新疗法的研究、开发和商业化。公司坚持源头创新的研发理念，以推出全球首创药物（First-in-class）和具有突破性潜力的治疗方法为目标，旨在填补全球未被满足的临床需求。基于行业领先的转化科学和新药分子设计与筛选技术平台，公司已建立了七款具备全球竞争力的产品管线，其中两大处于全球关键性临床试验阶段的领先产品，均已在中国获批上市。',
    about_2: ' '
  },
  strategy: {
    strategy_1: '以治疗肿瘤和免疫性疾病为目标',
    strategy_2: '保持在转化科学及药化和分子设计领域的竞争优势',
    strategy_3: '自主研发为主，着眼全球市场'
  },
  development_history: [
    {
      year: '2017-10',
      text: '迪哲医药成立'
    },
    {
      year: '2017-12',
      text: '第一个临床试验批准'
    },
    {
      year: '2019-08',
      text: '第一个临床试验完成'
    },
    {
      year: '2020-10',
      text: '第一个关键性临床试验启动'
    },
    {
      year: '2020-12',
      text: '舒沃替尼（Sunvozertinib）获CDE“突破性疗法认定”'
    },
    {
      year: '2021-12',
      text: '上交所科创板上市'
    },
    {
      year: '2022-01',
      text: '舒沃替尼（Sunvozertinib）获FDA“突破性疗法认定”'
    },
    {
      year: '2022-02',
      text: '戈利昔替尼（Golidocitinib）获FDA“快速通道认定”'
    },
    {
      year: '2023-08',
      text: '舒沃哲 ® （通用名：舒沃替尼）新药上市申请获NMPA批准'
    },
    {
      year: '2024-06',
      text: '高瑞哲®（通用名：戈利昔替尼）新药上市申请获NMPA批准'
    }
  ],
  contact_us: '联系我们',
  more: '更多',
  management: '管理团队',
  board: '董事会',
  jobs: '工作机会',
  campus: '校园招聘',
  copyright: '© 2024 迪哲医药股份有限公司版权所有',
  site_ref: '备案编号: ',
  //   home: "主页",
  read_more: '阅读更多',
  news_list: '新闻列表',
  news_detail: '新闻详情',
  return_to_news_list: '返回新闻列表',
  oncology: '肿瘤',
  non_oncology: '非肿瘤',
  expand_access_intro: '同情用药政策',
  expand_access_9008: 'Sunvozertinib (DZD9008)',
  expand_access_detail_9008:
    "At Dizal we aspire to discover and develop differentiated therapeutics for the treatment of cancer and immunological diseases. One of the Dizal's lead products, sunvozertinib, is an oral EGFR tyrosine kinase inhibitor (TKI). It is currently being investigated as a single agent in phase 2 and phase 3 clinical trials for the treatment of Non-Small Cell Lung Cancer (NSCLC) patients with EGFR Exon20ins mutation. We are enrolling and conducting clinical trials aiming at gaining regulatory approval to make sunvozertinib available to all eligible patients as quickly as possible. As such, we believe participation in our clinical trials is the most appropriate way to access sunvozertinib at this stage of development. Information about our clinical trials, including eligibility criteria and locations, is available at <a style='color:#ca113a;' target='_blank' href='https://clinicaltrials.gov/ct2/show/NCT03974022'>clinicaltrials.gov</a>.<br><br>Dizal understands the interest of patients in accessing drugs, such as sunvozertinib, outside of clinical trials and prior to regulatory approval for potentially life-threatening diseases. Because sunvozertinib is an investigational drug, and its efficacy and safety are still under evaluation, sunvozertinib can only be administered in accordance with local investigational drug requirement by an experienced physician. <br><br>Dizal now offers Individual Patient Access for its investigational drug sunvozertinib for the treatment of adult patients with Advanced Non-Small Cell Lung Cancer (NSCLC), with EGFR or HER2 mutation, at the sites participating in ongoing clinical trials of sunvozertinib. Individual patients at these sites may be able to access sunvozertinib if they are ineligible for the available standard of care and are recommended by the treating physician to the Individual Patient Access Program. <br><br>In order to meet FDA requirements, Dizal will provide a Letter of Authorization (LOA), referencing the content in Dizal’s US IND, to each treating physician to support their written requests (IND) for individual patient use. This same principle may be applied to countries with IND/CTA of sunvozertinib opened to fulfill the local regulatory requirements.",
  expand_access_4205: 'Golidocitinib (DZD4205, AZD4205)',
  expand_access_detail_4205:
    "At Dizal, we aspire to discover and develop differentiated therapeutics for the treatment of cancer and immunological diseases. One of Dizal's lead products, golidocitinib, is an oral, potent, highly selective Janus kinase 1 (JAK1) inhibitor. It is currently being investigated as a single agent in a phase 2 clinical trial for the treatment of patients with relapsed/refractory peripheral T-cell lymphoma (r/r PTCL). We are conducting clinical trials aiming at gaining regulatory approval to make golidocitinib available to all eligible patients as quickly as possible. As such, we believe participation in our clinical trials is the most appropriate way to access golidocitinib at this stage of development. Information about our clinical trials, including eligibility criteria and locations, is available at <a style='color:#ca113a;' target='_blank' href='https://clinicaltrials.gov/study/NCT04105010?term=AZD4205&checkSpell=false&rank=4'>clinicaltrials.gov</a>.<br><br>Dizal understands the interest of patients in accessing drugs, such as golidocitinib, outside of clinical trials and prior to regulatory approval for potentially life-threatening diseases. Because golidocitinib is an investigational drug, and its efficacy and safety are still under evaluation, golidocitinib can only be administered in accordance with local investigational drug requirements by an experienced physician. <br><br>Dizal now offers Individual Patient Access to the investigational drug golidocitinib for the treatment of adult patients with r/r PTCL at the sites participating in ongoing clinical trials of golidocitinib. Individual patients at these sites may be able to access golidocitinib if they are ineligible for the available standard of care and are recommended by the treating physician to the Individual Patient Access Program. <br><br>In order to meet the FDA's requirements, Dizal will provide a Letter of Authorization (LOA), referencing the content in Dizal's US IND, to each treating physician to support their written requests (IND) for individual patient use. The same principle may be applied to countries with IND/CTA of golidocitinib opened to fulfill the local regulatory requirements.",
  pipeline: {
    table: {
      project: '研发项目',
      discovery: '临床前',
      IND_Enabling: '临床申报',
      Ph1_does: '剂量递增',
      Ph2_proof: '概念验证',
      Ph3_pivotal: '注册试验',
      NDA: 'NDA',
      approval: '获批',
      Ph1: 'I期',
      Ph2: 'II期',
      Ph3: 'III期',
      commercialRights: '商业权利',
      global: '全球',
      dizal_AZ_split: '和AZ分享',
      PTCL: '肺癌',
      HM: '血液肿瘤',
      HMSolidTumors: '实体肿瘤、血液肿瘤',
      autoimmuneDiseases: '免疫性疾病',
      solidLiquidTumors: '实体及液体肿瘤',
      solidTumors: '实体肿瘤',
      Sunvozertinib: '舒沃哲',
      Golidocitinib: '高瑞哲',
      DZD1516: 'DZD1516',
      DZD2269: 'DZD2269',
      DZD8586: 'DZD8586',
      DZD6008: 'DZD6008',
      GW5282: 'GW5282',
      CKD: '慢性肾病',
      anti_virus: '呼吸感染',
      ps: '（注：图示代表最快适应症对应的开发阶段）',
      hematologicalMalignancy: '血液肿瘤',
      sunvozertinibTip: ['中美突破性疗法', '中国纳入优先审评'],
      GolidocitinibTip: ['美国快速通道认定', '美国孤儿药资格认定', '中国纳入优先审评'],
      recognition: '监管认定 '
    }
  },
  members: {
    //   张小林
    XiaolinZhang: {
      name: '张小林 博士',
      position: ['创始人/首席执行官'],
      edu: ['北京大学客座教授', '美国俄勒冈州立大学分子遗传学博士'],
      detail: [
        '张博士拥有超过20年的新药研发管理经验，曾担任阿斯利康全球创新研发中心副总裁、亚洲及新兴市场创新研发中心负责人。张博士于1998年加入阿斯利康波士顿研究中心，担任全球项目负责人、研发总监等职，也是全球癌症、抗感染研究领域高级管理团队成员之一；2006年，回国建立了阿斯利康中国研发中心，领导了阿斯利康全球肿瘤转化医学、亚洲及新兴市场创新药物研发项目。在阿斯利康任职期间，曾主导或参与了易瑞沙、泰瑞沙，AZD3759、AZD2954等原创新药研发。',
        '曾就职于哈佛大学医学院癌症中心、波士顿大学生物分子工程研究中心等。'
      ]
    },
    // 杨振帆
    PamelaYang: {
      name: '杨振帆 博士',
      position: ['首席医学官'],
      edu: ['香港大学博士', '四川大学华西临床医学院临床医学硕士'],
      detail: [
        '杨博士拥有近10年的一线临床工作经历、10余年的转化医学及新药研发管理经验。曾历任阿斯利康亚洲及新兴市场创新研发中心医学和药物研发项目负责人，生物及临床医学副总裁。在阿斯利康任职期间，先后领导了易瑞沙、泰瑞沙等10余个转化医学项目；主持了AZD3759、AZD1390等多个原创药物研发。',
        '2004年于香港大学任科研教授；作为肝胆外科医生，先后任职于华西医科大学附属第一医院（现四川大学华西医院）、重庆医科大学附属第一医院。'
      ]
    },
    HongbinLyu: {
      name: '吕洪斌先生',
      position: ['首席财务官、董事会秘书'],
      edu: ['中央财经大学工商管理硕士、CFA '],
      detail: [
        '吕先生在投资银行及相关业务方面拥有20年经验，曾历任华泰联合大健康行业部负责人、董事总经理以及中金公司成长型企业投资银行部医疗医药行业组负责人。吕先生主导完成的医疗项目包括：药明康德A股和H股IPO，迈瑞医疗A股IPO，三生国健A股科创板IPO，爱尔眼科非公开发行及并购重组，奥赛康药业借壳上市，三生药业港股IPO等。'
      ]
    },
    // 吴清漪
    AnitaWu: {
      name: '吴清漪女士',
      position: ['首席商务官'],
      edu: [''],
      detail: [
        '吴女士拥有超过25年跨国药企和生物科技公司行业经验。 在加入迪哲之前，吴女士担任百济神州大中华区首席商务官，负责建立了商业运营平台及广阔市场团队，以提升团队整合和协作能力和运营效率；主导了三款产品列入国家医保目录。',
        '吴女士还曾供职于赛诺菲、阿斯利康、辉瑞和健赞等跨国药企。在赛诺菲中国任职期间，吴女士担任特药事业部总经理，积极和多方合作，致力于推动中国罕见病政策落地。在阿斯利康中国任职期间，吴女士曾担任糖尿病业务部的执行总监、肿瘤业务部的区域市场总监和销售总监。吴女士生物制药经历始于健赞，还曾供职于辉瑞公司担任全球和亚太区肿瘤产品负责人等职位。'
      ]
    },
    // 陈素勤
    SusanChen: {
      name: '陈素勤女士',
      position: ['临床运营 高级副总裁'],
      edu: ['中国药科大学中药学学士'],
      detail: [
        '陈女士拥有超过20年的临床运营及管理经验。陈女士曾任阿斯利康中国临床运营中心负责人及罗氏亚太开发中心中国临床管理和监察部负责人。在阿斯利康任职期间，陈女士建立了阿斯利康全球临床运营中国中心，与全球其他三大运营中心并行；领导I至III期全球临床研究，涉及心血管、消化、呼吸及肿瘤等领域，如泰瑞沙、AZD3759、PDL-1、CAZ-AVI 等临床研究，覆盖亚洲、欧洲、美洲三十余个国家。',
        '陈女士在罗氏任职期间，领导中国团队开展三十余项全球或中国注册研究，包括赫赛汀、特罗凯及安维汀等重要产品。陈女士还曾供职礼来、田边制药等跨国医药公司。'
      ]
    },
    // 曾庆北
    QingbeiZeng: {
      name: '曾庆北 博士',
      position: ['首席科学家 高级副总裁'],
      edu: ['美国俄亥俄州立大学有机化学博士'],
      detail: [
        '曾博士拥有超过20年的新药设计与研发经验，参与了多个创新药物研发项目，涉及癌症、病毒感染、免疫性关节炎、过敏等疾病领域；成功将多个项目推进临床阶段。曾博士曾任阿斯利康亚洲及新兴市场创新研究中心化学部主任，在阿斯利康任职期间, 是第一个由中国团队自主研发的临床候选新药AZD3759的主要发明人。曾博士还曾先后就职于美国先灵葆雅和默克制药公司。'
      ]
    },
    // 徐汉忠
    HonchungTsui: {
      name: '徐汉忠 博士',
      position: ['药物化学 高级副总裁'],
      edu: ['斯坦福大学博士后', '美国俄亥俄州立大学化学博士'],
      detail: ['徐博士拥有近20年的新药研发工作及管理经验，曾担任阿斯利康亚洲及新兴市场创新研究中心化学部总监。徐博士还曾先后就职于美国先灵葆雅和默克制药公司，曾作为主要成员成功研发了抗化疗呕吐新药Rolapitant，目前已在欧美地区上市；并曾参与了多个肿瘤、免疫相关小分子靶向新药的研发项目。']
    },
    // 张世英博士
    SHIH_YING_CHANG: {
      name: '张世英 博士',
      position: ['化学，生产与控制部副总裁'],
      edu: ['马里兰大学帕克分校化学工程博士'],
      detail: [
        '张博士拥有超过15年创新药制剂开发、技术转移、临床生产经验，曾担任和记黄埔医药制剂研发部执行总监，还曾供职于百时美施贵宝新泽西，致力于研究原料药晶型及干燥，制剂开发，商业化生产放大, 以及技术转移。',
        '曾参与的新药研发项目包括近四十种小分子化合物, 和1个蛋白质分子，涵盖自临床前研究到商业用生产的技术转移；并曾参与撰写5项NDA申请，其中4项向FDA提交、1项向CFDA提交。开发的重要技术包括：溶液型增溶处方、自微乳化释药系统、喷雾干燥分散体、共沉淀、水雾激活干法制粒、活性成分包衣法。'
      ]
    },
    // 张知为
    VioletZhang: {
      name: '张知为女士',
      position: ['公司运营 副总裁'],
      edu: ['香港大学组织与人力资源管理硕士', '华东师范大学法学学士'],
      detail: ['张女士拥有10余年的医疗医药行业管理经验，曾任阿斯利康全球研发中国区人力资源负责人。']
    }
  },
  boards: {
    // 张小林博士
    XiaolinZhang: {
      name: '张小林博士',
      position: ['首席执行官, 迪哲医药'],
      detail: [
        '张博士自2017年起任迪哲医药董事长、首席执行官。',
        '张博士拥有超过20年的新药研发管理经验，曾担任阿斯利康全球创新研发中心副总裁、亚洲及新兴市场创新研发中心负责人。张博士于1998年加入阿斯利康波士顿研究中心，担任全球项目负责人、研发总监等职，也是全球癌症、抗感染研究领域高级管理团队成员之一；2006年，回国建立了阿斯利康中国研发中心，领导了阿斯利康全球肿瘤转化医学、亚洲及新兴市场创新药物研发项目。在阿斯利康任职期间，曾主导或参与了易瑞沙、泰瑞沙，AZD3759、AZD2954等原创新药研发。',
        '曾就职于哈佛大学医学院癌症中心、波士顿大学生物分子工程研究中心等。'
      ]
    },
    // 吕大忠博士
    SimonLu: {
      name: '吕大忠博士',
      position: ['董事总经理, 国投创新投资管理有限公司'],
      detail: [
        '吕博士自2017年起任迪哲医药董事。',
        '吕博士于2009年8月加入国投创新投资管理有限公司，担任董事总经理职务，目前主要负责公司医疗健康领域的投资；曾经就职于中法资本、上海联创投资管理公司、加拿大丰业银行、中国国际金融有限公司和安达信会计师事务所，拥有20多年投资及咨询领域从业经验。吕博士就读于天津南开大学获得经济学学士和博士学位，以及加拿大McGill大学工商管理硕士学位。'
      ]
    },
    // 傅晓
    // Fuxiao: {
    //   name: '傅晓',
    //   position: ['董事总经理, 国投创新投资管理有限公司'],
    //   detail: ['傅女士自2017年起任迪哲医药董事。', '傅女士拥有超过25年投资和金融服务的从业经验，曾任WLR中国基金的高级副总裁，曾就职Affinity Equity Partners、高盛（亚洲）的投资银行部和安达信会计师事务所。傅女士拥有中央财经大学学士学位以及伦敦政治经济学院的硕士学位']
    // },
    // Menelas Pangalos 博士
    // MenelasPangalos: {
    //   name: "Menelas Pangalos 博士",
    //   position: ["阿斯利康全球执行副总裁, 生物制药研发"],
    //   detail: [
    //     "Pangalos博士自2017年起担任迪哲医药董事。",
    //     "自2019年1月起，担任阿斯利康全球生物药物研发执行副总裁，领导全球心血管、肾脏及代谢业务部及呼吸疾病从早期发现至临床后期的研发活动。在此之前，担任阿斯利康创新药物及早期研发部和全球业务发展执行副总裁，领导阿斯利康全球三大洲2500人的研究和早期开发工作。",
    //     "自2010年加入阿斯利康以来，Pangalos博士在重塑公司科学至上的发展方向中发挥了重要作用。他引领了研发生产力的转型，推动了阿斯利康与学术界、生物技术领域和同行组织间的合作，发起了促进开放创新的项目，并培育了科学驱动，奖赏求真行为的文化。作为阿斯利康科学领头人之一，Pangalos博士在全球顶级学术期刊上发表了145余篇通过了同行评审的文章，并担任过多本书籍和期刊的编辑。 他也是伦敦国王学院神经科学的客座教授，并获得了格拉斯哥大学荣誉理学博士学位。",
    //     "Pangalos博士是英国医学科学院、英国皇家生物学学会及剑桥大学克莱尔学院院士，同时也是英国医学研究理事会（MRC）成员，担任生命科学委员会创新、临床研究及数据专家组的联席主席，并且是生命科学战略实施委员会和剑桥大学贾吉商学院的英国制药业理事会成员。Mene还负责阿斯利康在剑桥的全新研发中心和全球总部的建立——这座一流的设施旨在通过协作激发科学创新，将在英国生命科学的未来发展中发挥重要作用。",
    //   ],
    // },
    /* Rodolphe Grépinet*/
    Rodolphe: {
      name: 'Rodolphe Grépinet',
      position: ['阿斯利康企业发展副总裁'],
      detail: [
        'Grépinet先生自2017年起担任迪哲医药董事。',
        'Grepinet先生负责阿斯利康在全球所有治疗领域转型机会的评估和执行，直接并向首席战略官汇报。过去二十年，Grepinet先生一直参与企业并购和业务拓展交易的评估、构建和谈判，累计成交额超3000亿美元。',
        '在2014年加入阿斯利康之前，Grepinet先生曾在欧洲和美国担任并购投资银行家长达17年，为全球生命科学行业的客户提供咨询服务。他先后在摩根士丹利，瑞银和德意志银行担任要职，最后成为了一家美国生命科学战略咨询公司的合伙人，并在欧洲也合伙成立了该公司。'
      ]
    },
    // LinLiang: {
    //   name: '林亮',
    //   position: ['礼来亚洲基金合伙人'],
    //   edu: [''],
    //   detail: [
    //     '林先生自2020年起任迪哲医药董事。',
    //     '林先生是礼来亚洲基金的合伙人。此前他在葛兰素史克负责收购兼并、产品引进和对外授权，在默克-雪兰诺负责核心产品的市场营销，以及在三九医药创建并领导战略规划及商务拓展业务。林先生拥有中国药科大学药物化学硕士和学士学位，以及中欧国际工商学院工商管理硕士学位。'
    //   ]
    // },
    // HongbinLyu: {
    //   name: '吕洪斌',
    //   position: ['首席财务官, 迪哲医药'],
    //   detail: [
    //     '吕先生自2020年起任迪哲医药董事、董事会秘书和首席财务官。',
    //     '吕先生在投资银行及相关业务方面拥有20年经验，曾历任华泰联合大健康行业部负责人、董事总经理以及中金公司成长型企业投资银行部医疗医药行业组负责人。吕先生主导完成的医疗项目包括：药明康德A股和H股IPO，迈瑞医疗A股IPO，三生国健A股科创板IPO，爱尔眼科非公开发行及并购重组，奥赛康药业借壳上市，三生药业港股IPO等'
    //   ]
    // },
    Jiangbin: {
      name: '姜斌博士',
      position: ['独立董事'],
      detail: ['姜博士自2020年9月起担任迪哲医药独立董事。', '姜博士现任上海交通大学医学院附属第九人民医院肿瘤科主任，曾任上海第二军医大学长海医院呼吸科及肿瘤科主治医师、讲师。姜博士拥有上海交通大学医学院肿瘤学博士学历，持有执业医师资格。']
    },
    Wangxuegong: {
      name: '王学恭先生',
      position: ['独立董事'],
      detail: ['王先生自2020年9月起担任迪哲医药独立董事。', '王先生在多家生物医药公司担任独立董事，同时亦担任中国医药企业管理协会副会长、中国医药包装协会副会长。王先生曾就职于华北制药集团有限责任公司。', '王先生拥有南开大学工商管理硕士学历。']
    },
    Zhuguanshan: {
      name: '朱冠山博士',
      position: ['独立董事'],
      detail: [
        '朱博士自2020年9月起担任迪哲医药独立董事。',
        '朱博士任厦门艾德生物医药科技股份有限公司科学顾问，曾就职于阿斯利康投资（中国）有限公司、上海基康生物技术有限公司、上海长海医院，曾在美国国家卫生研究院酒精成瘾和酒精滥用研究所担任研究学者。朱博士曾就读于德国埃森大学医学院，获得人类遗传学博士学位，持有执业医师资格、制药工程高级工程师资格。'
      ]
    },
    MeixiaAn: {
      name: '安梅霞女士',
      position: ['独立董事'],
      detail: ['安女士自2024年12月起担任迪哲医药独立董事。', '安女士现任黄山学院经济管理学院教师，曾就职于上海同济科技实业股份有限公司、中国医药工业研究总院、天邦食品股份有限公司。安女士拥有上海财经大学经济学硕士学历，持有注册会计师、高级会计师资格。']
    }
  },
  diseaseAreas: {
    lung: {
      key: 'lung',
      name: '肺癌',
      img: 'DA1@2X.jpg',
      intro: [
        '在中国乃至世界范围，肺癌的发病率和死亡率均占所有恶性肿瘤的第一位，5年生存率很低，仅为15-20%。非小细胞肺癌约占所有肺癌的80%，虽然市场上已有一系列靶向药物获批或正在研发期间，由于疾病机理复杂多样，仍有大量病人无法获益，是一个未能解决的临床难题。由迪哲医药独立研发的一个激酶突变特异性抑制剂，已经成功筛选出候选化合物。',
        '临床前试验表明，候选化合物能够有效抑制肺癌肿瘤细胞上该激酶及其下游信号传导通路的激活，从而抑制肿瘤细胞的生长。与目前已经获批的同类靶向药物相比，其在共同目标突变类型上效果相似甚至更优，而又能抑制以往药物在临床上无法覆盖的突变类型。可以预见该新药进入临床后会兼具疗效，安全性，和覆盖面，给更多的非小细胞肺癌患者带来希望，成为新一代肺癌靶向药物的标杆。与此同时，转化科学和临床前的数据显示，此抑制剂的适应症还可能扩展至乳腺癌等其它癌症类型，使更多病人获益。迪哲医药研发的该激酶突变特异性抑制剂属于中国原研新药，预计在2019年进入全球范围的I期临床试验，真正实现医药创新“走出中国，迈向世界”的宏伟目标，其学术意义、经济效益和国际影响不可估量。'
      ]
    },
    kidney: {
      key: 'kidney',
      name: '慢性肾病',
      img: 'DA2@2X.jpg',
      intro: [
        '蛋白尿是肾脏损伤的重要临床特征，长期持续性蛋白尿可导致肾功能降低最终导致终末期肾病。由迪哲医药（原阿斯利康中国创新中心团队）发现、与阿斯利康国际团队联合开发的针对慢性肾病蛋白尿的一个1.1类小分子抑制剂，已经成功地筛选出2个候选化合物，目前正处于临床前研发阶段。体外试验证明，候选化合物能够有效保护肾小球足细胞免受损伤。在模拟人类疾病状态的转基因大鼠模型中，候选化合物能够有效地恢复肾小球滤过屏障中的足细胞突起和延缓足细胞的丢失、剂量依赖性地控制动物体内蛋白尿、减缓肾功能的损伤并且显著改善肾脏的组织病理。在与目前临床的标准治疗药物进行比对的体内药理学试验中，其降低蛋白尿的效果显著优于临床的标准治疗药物。',
        '此药物旨在用于治疗伴有大量蛋白尿的慢性肾病患者，尤其是对激素治疗产生原发抗性的局灶阶段性肾小球肾炎，帮助解决这一临床难题。此外，一些转化医学的数据提示此化合物的适应症还可能扩展至糖尿病性肾病、心力衰竭等领域。此化合物在研发历程上遥遥领先于其他同类药物，预计于2019-2020年进入全球临床试验，并将率先成为进入市场的第一个作用于足细胞的特异性靶向抑制剂。可以预见药物进入临床后会成为不可替代的新药，给患者带来希望，其学术意义、商业价值和社会效益显著。'
      ]
    },
    inflammatory: {
      key: 'inflammatory',
      name: '炎症性肠病',
      img: 'DA3@2X.jpg',
      intro: [
        '炎症性肠病（inflammatory bowel disease, IBD）是一种病因不明的慢性非特异性肠道炎症性疾病，包括克罗恩病（Crohn’s disease, CD）和溃疡性结肠炎（Ulcerative Colitis，UC），已成为消化系统常见疾病和慢性腹泻的主要病因。在中国，UC和CD的患病率分别为11.6/10万和1.4/10万。对于IBD，目前常规治疗存在疗效不确切，不良反应较多等治疗限制，且IBD的患者多为青壮年，疾病反复发作，迁延终身，给社会造成重大疾病负担的同时，也对患者个人的生活质量带来极大影响。',
        '由迪哲医药独立研发的一个激酶抑制剂，已经成功筛选出候选化合物。临床前试验表明，该化合物能够有效抑制包括炎症性肠病在内的自身免疫性疾病信号传导通路的激活，对多个参与IBD或其他自身免疫疾病发病机制的细胞因子进行调控。与目前已经获批或在研的同类药物相比，该药物对于作用靶点有更高的选择性，并具有较高的生物利用度和较长的半衰期，预见该新药进入临床后，在提供有效的治疗外同时具有良好的安全性，将给更多自身免疫性疾病的患者带来新的治疗选择。同时，基于现有的转化科学和临床前的数据， 该药物的适应症有望扩展至其它自身免疫性疾病，使更多此类患者获益。迪哲医药研发的该激酶抑制剂属于中国原研新药，预计在2019年进入全球范围的I期临床研究，实现全球同步研发。'
      ]
    },
    anti_virus: {
      key: 'anti_virus',
      name: '抗病毒项目',
      img: 'DA4@2X.jpg',
      intro: [
        '呼吸道传染疾病可由病毒、细菌、支原体、衣原体、军团菌等微生物感染引起，具有季节性高发，发病率高，人群普遍易染等特点。由于抗生素的发明与使用，因细菌感染诱发的下呼吸道感染比率逐年降低。但由于全球变暖和大气污染等因素影响，病毒性感染引起的下呼吸道感染比率逐年增加，并且成为引起世界范围内5岁以下儿童死亡的首位原因。在小于6个月的婴幼儿中，有45%的住院与死亡病例是因病毒诱发的急性下呼吸道感染引起的。对于65岁以上的老人和免疫缺陷或心肺功能不全的成人，病毒感染也会引发严重的下呼吸道感染。现在针对呼吸道病毒感染并没有有效的治疗手段。',
        '针对这一空白，迪哲医药独立研发了一种新型抗病毒小分子化合物。在细胞水平实验中，该化合物可以有效抑制病毒复制与增殖，对临床毒株显示了广泛的抑制作用。对同类药物产生的耐药毒株显示的良好增殖抑制效果，表明该化合物具有独特的作用位点。初步实验结果还显示这类小分子化合物有用于病毒感染的预防和治疗的可能。在动物实验中，该类化合物可以明显降低病毒滴度， 并能显著改善动物因病毒感染引起的气道组织坏死与肺部炎症。该化合物属于中国原研新药，现处于临床前开发阶段。'
      ]
    }
  },
  publications: {
    key: '刊物',
    core: '迪哲以科学为本',
    intro: '我们的科学家定期在顶尖学术期刊发表研究成果，并在全球科学大会上发表口头演讲。',
    tab: {
      Sunvozertinib: '舒沃替尼',
      Golidocitinib: '戈利昔替尼',
      DZD2269: 'DZD2269',
      DZD8586: 'DZD8586',
      DZD6008: 'DZD6008',
      DZD1516: 'DZD1516'
    },
    Sunvozertinib: [
      {
        intro: '探索肿瘤组织和血浆ctDNA的EGFR Exon20ins突变状态与舒沃替尼临床疗效的相关性研究结果入选2023年世界肺癌大会（WCLC）简短口头报告',
        dec: [
          {
            title: '探索肿瘤组织和血浆ctDNA的EGFR Exon20ins突变状态与舒沃替尼临床疗效的相关性',
            item: [
              {
                date: '2023年9月11日',
                detail: {
                  报告人: '王孟昭',
                  会议: '2023年世界肺癌大会',
                  分会场: 'MA14. NSCLC的基因生物标志物'
                },
                link: 'https://cattendee.abstractsonline.com/meeting/10925/Session/113'
              }
            ]
          }
        ]
      },
      {
        intro: '舒沃替尼治疗携带EGFR 20号外显子插入突变的非小细胞肺癌：首个关键性临床研究结果入选2023年美国临床肿瘤学会（ASCO）口头报告',
        dec: [
          {
            title: '舒沃替尼治疗携带EGFR 20号外显子插入突变的非小细胞肺癌：首个关键性临床研究结果',
            item: [
              {
                date: '2023年6月6日',
                detail: {
                  报告人: '王孟昭',
                  会议: '2023年美国临床肿瘤学会',
                  分会场: '肺癌–转移性非小细胞肺癌'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/220375'
              }
            ]
          }
        ]
      },
      {
        intro: '舒沃替尼一线治疗携带EGFR 20号外显子插入突变型晚期非小细胞肺癌患者的疗效和安全性分析在2023年美国临床肿瘤学会（ASCO）予以公布',
        dec: [
          {
            title: '舒沃替尼一线治疗携带EGFR 20号外显子插入突变型晚期非小细胞肺癌患者的疗效和安全性',
            item: [
              {
                date: '2023年6月4日',
                detail: {
                  报告人: '徐燕',
                  会议: '2023年美国临床肿瘤学会',
                  分会场: '肺癌–转移性非小细胞肺癌'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/218846'
              }
            ]
          }
        ]
      },
      {
        intro: '舒沃替尼在EGFR TKI治疗失败的EGFR敏感突变型晚期非小细胞肺癌中的抗肿瘤活性在2023年美国临床肿瘤学会（ASCO）予以公布',
        dec: [
          {
            title: '舒沃替尼在EGFR TKI治疗失败的EGFR敏感突变型晚期非小细胞肺癌中的抗肿瘤活性',
            item: [
              {
                date: '2023年6月4日',
                detail: {
                  报告人: '杨志新',
                  会议: '2023年美国临床肿瘤学会',
                  分会场: '肺癌–转移性非小细胞肺癌'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/218922'
              }
            ]
          }
        ]
      },
      {
        intro: '生物标志物与舒沃替尼对EGFR 20号外显子插入突变型非小细胞肺癌患者抗肿瘤疗效的相关性研究入选第25届全国临床肿瘤学大会暨2022年CSCO学术年会口头报告',
        dec: [
          {
            title: '生物标志物与舒沃替尼对EGFR 20号外显子插入突变型非小细胞肺癌患者抗肿瘤疗效的相关性研究',
            item: [
              {
                date: '2022年11月9日',
                detail: {
                  报告人: '徐燕',
                  会议: '第25届全国临床肿瘤学大会暨2022年CSCO学术年会',
                  分会场: 'CSCO非小细胞肺癌专家委员会肺癌口头报告专场'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=28'
              }
            ]
          }
        ]
      },
      {
        intro: '舒沃替尼用于治疗携带EGFR 20号外显子插入突变型的非小细胞肺癌患者的II期关键性研究初步结果入选第25届全国临床肿瘤学大会暨2022年CSCO学术年会口头报告',
        dec: [
          {
            title: '舒沃替尼（DZD9008）在携带EGFR 20号外显子插入突变型的非小细胞肺癌患者中的II期关键性研究初步结果',
            item: [
              {
                date: '2022年11月5日',
                detail: {
                  报告人: '王孟昭',
                  会议: '第25届全国临床肿瘤学大会暨2022年CSCO学术年会',
                  分会场: '创新药物临床研究数据专场1'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=28'
              }
            ]
          }
        ]
      },
      {
        intro: '舒沃替尼用于治疗EGFR 20号外显子插入突变型晚期非小细胞肺癌研究结果入选2022年北美洲肺癌大会（NACLC）口头报告',
        dec: [
          {
            title: '舒沃替尼用于治疗EGFR 20号外显子插入突变型晚期非小细胞肺癌研究结果',
            item: [
              {
                date: '2022年9月25日',
                intro: '摘要OA01.07',
                detail: {
                  报告人: 'Lyudmila Bazhenova',
                  会议: '2022年北美洲肺癌大会',
                  分会场: '口头摘要分会场01（OA01）'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=24'
              }
            ]
          }
        ]
      },
      {
        intro: '舒沃替尼用于治疗EGFR 20号外显子插入突变型晚期非小细胞肺癌中国注册临床的初步分析结果在2022年欧洲肿瘤内科学会（ESMO）予以公布',
        dec: [
          {
            title: 'WU-KONG6研究：舒沃替尼用于治疗EGFR 20号外显子插入突变型晚期非小细胞肺癌的注册临床研究',
            item: [
              {
                date: '2022年9月10日',
                intro: '报告编号：987P',
                detail: {
                  第一作者: '王孟昭',
                  会议: '2022年欧洲肿瘤内科学会',
                  分会场: '海报分会场14'
                },
                link: 'https://oncologypro.esmo.org/meeting-resources/esmo-congress/sunvozertinib-for-nsclc-patients-with-egfr-exon-20-insertion-mutations-preliminary-analysis-of-wu-kong6-the-first-pivotal-study'
              }
            ]
          }
        ]
      },
      {
        intro: '舒沃替尼治疗既往接受含铂化疗失败的EGFR 20号外显子插入突变型晚期非小细胞肺癌的最新研究成果在2022年世界肺癌大会（WCLC）予以公布',
        dec: [
          {
            title: '舒沃替尼用于EGFR 20号外显子插入突变型晚期非小细胞肺癌',
            item: [
              {
                date: '2022年7月8日',
                intro: '海报编号：EP08.02-029',
                detail: {
                  报告人: 'James Chih-Hsin Yang',
                  会议: '2022年世界肺癌大会',
                  分会场: 'EP08.02-转移性非小细胞肺癌-分子靶向治疗'
                },
                link: 'https://wclc2022.iaslc.org/wp-content/uploads/2022/07/WCLC2022-Abstract-Book.pdf'
              }
            ]
          }
        ]
      },
      {
        intro: '舒沃替尼治疗既往接受含铂化疗及前线免疫治疗失败的EGFR 20号外显子插入突变型晚期非小细胞肺癌临床试验结果入选2022年度美国临床肿瘤学会（ASCO）大会壁报讨论',
        dec: [
          {
            title: '舒沃替尼在既往含铂化疗及前线免疫治疗失败后EGFR 20号外显子插入突变型晚期非小细胞肺癌人群的疗效',
            item: [
              {
                date: '2022年6月7日',
                intro: '摘要编号：#9015',
                detail: {
                  第一作者: 'Pasi A. Janne',
                  会议: '2022年美国临床肿瘤学会',
                  分会场: '肺癌-非小细胞肺癌D1厅'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/209838'
              }
            ]
          }
        ]
      },
      {
        intro: '舒沃替尼用于治疗EGFR 20号外显子插入突变型晚期非小细胞肺癌的研究成果在《Cancer Discovery》上发表',
        dec: [
          {
            title: '舒沃替尼-一种用于治疗既往接受含治疗失败的EGFR 20号外显子插入突变型晚期非小细胞肺癌的高选择性EGFR酪氨酸激酶抑制剂',
            item: [
              {
                detail: {
                  第一作者: '王孟昭，James Chih-Hsin Yang',
                  影响因子: '39.397'
                },
                link: 'https://aacrjournals.org/cancerdiscovery/article/12/7/1676/705231/Sunvozertinib-a-Selective-EGFR-Inhibitor-for'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD9008（口服、高选择性EGFR/HER2抑制剂）用于治疗EGFR 20号外显子插入突变非小细胞肺癌的I期临床研究数据入选2021年第22届世界肺癌大会（WCLC）口头报告',
        dec: [
          {
            title: 'DZD9008，一种口服、高选择性EGFR/HER2抑制剂，用于治疗EGFR 20号外显子插入突变非小细胞肺癌的I期临床研究',
            item: [
              {
                date: '2021年9月13日',
                intro: '摘要编号: #402',
                detail: {
                  报告人: 'Pasi A. Janne',
                  会议: '2021年第22届世界肺癌大会',
                  分会场: 'OA15 - 治疗EGFR  20号外显子插入突变和 MET 跳跃突变的潜在分子靶向药物'
                },
                link: 'https://library.iaslc.org/conference-program?product_id=24&author=&category=&date=&session_type=&session=&presentation=&keyword=DZD9008&cme=undefined&'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD9008用于治疗EGFR 20号外显子插入突变非小细胞肺癌的I期临床研究的初步安全性和有效性数据作为口头报告在2021年度美国临床肿瘤学会（ASCO）大会予以公布',
        dec: [
          {
            title: 'DZD9008用于治疗EGFR 20号外显子插入突变非小细胞肺癌的I期临床研究的初步安全性和有效性',
            item: [
              {
                date: '2021年6月5日',
                intro: '摘要9008：DZD9008用于治疗EGFR 20号外显子插入突变非小细胞肺癌的I期临床研究的初步安全性和有效性。',
                detail: {
                  作者: 'James Chih-Hsin Yang, Mengzhao Wang, Paul Mitchell, Jian Fang, Weiqi Nian, Chao-Hua Chiu, Jianying Zhou, Yanqiu Zhao, Wu-Chou Su, D. R. Camidge, Tsung-Ying Yang, Viola W. Zhu, Michael Millward, Yun Fan, Wen Tsung Huang, Ying Cheng, Liyan Jiang, Li Zheng, Xiuhui Ye, Pasi A. Janne',
                  会议: '2021美国临床肿瘤学会（ASCO）大会',
                  分会场: '转移性非小细胞肺癌'
                },
                link: 'https://meetinglibrary.asco.org/record/197248/abstract'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD9008，一种对携带EGFR或HER2基因20号外显子插入突变或其他驱动突变的非小细胞肺癌患者具有潜在抗癌疗效的EGFR抑制剂',
        dec: [
          {
            title: 'DZD9008，对EGFR和HER2基因的20号外显子插入突变及其他区驱动突变的非小细胞肺癌患者具有潜在抗癌能力',
            item: [
              {
                date: '2019年3月29日至4月3日',
                intro: '摘要3081：DZD9008，一种口服的、不抑制野生型的EGFR选择性抑制剂，用于治疗携带外显子20插入突变或其他驱动突变的非小细胞肺癌患者。',
                detail: {
                  作者: 'Yan Xu, Lin Zhang, Lifang Zhu, Yingchun Wang, Mei Wang, Zhenfan Yang.',
                  会议: '2019年美国癌症研究协会年会'
                },
                link: 'http://cancerres.aacrjournals.org/content/79/13_Supplement/3081'
              }
            ]
          }
        ]
      }
    ],
    Golidocitinib: [
      {
        intro: '戈利昔替尼研究成果在《Annals of Oncology》上发表',
        dec: [
          {
            title: '戈利昔替尼-一款高选择性的JAK1抑制剂在复发难治性外周T细胞淋巴瘤的I期剂量递增和扩展的研究',
            item: [
              {
                detail: {
                  第一作者: '宋玉琴'
                },
                link: 'https://www.annalsofoncology.org/article/S0923-7534(23)00828-1/fulltext#%20'
              }
            ]
          }
        ]
      },
      {
        intro: '戈利昔替尼治疗复发/难治性外周T细胞淋巴瘤（r/r PTCL）国际多中心注册临床试验（JACKPOT8）的主要结果入选第17届恶性淋巴瘤国际会议（ICML）口头报告',
        dec: [
          {
            title: '戈利昔替尼治疗复发/难治性外周T细胞淋巴瘤（r/r PTCL）国际多中心注册临床试验（JACKPOT8）的主要结果',
            item: [
              {
                date: '2023年6月15日',
                detail: {
                  报告人: 'Won-Seog Kim',
                  会议: '第17届恶性淋巴瘤国际会议',
                  分会场: '外周T细胞淋巴瘤'
                },
                link: 'https://onlinelibrary.wiley.com/doi/10.1002/hon.3163_43'
              }
            ]
          }
        ]
      },
      {
        intro: '戈利昔替尼治疗复发/难治性外周T细胞淋巴瘤（r/r PTCL）国际多中心注册临床研究最新数据入选2023年美国临床肿瘤学会（ASCO）口头报告',
        dec: [
          {
            title: '戈利昔替尼治疗复发/难治性外周T细胞淋巴瘤（r/r PTCL）国际多中心注册临床研究最新数据',
            item: [
              {
                date: '2023年6月6日',
                detail: {
                  报告人: '蔡清清',
                  会议: '2023年美国临床肿瘤学会',
                  分会场: '血液系统恶性肿瘤–淋巴瘤和慢性淋巴细胞白血病'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/218269'
              }
            ]
          }
        ]
      },
      {
        intro: '戈利昔替尼针对复发难治性外周T细胞淋巴瘤（r/r PTCL）的国际多中心注册临床试验数据和生物标志物初步分析结果在第64届美国血液学会（ASH）予以公布',
        dec: [
          {
            title: '戈利昔替尼针对复发难治性外周T细胞淋巴瘤（r/r PTCL）的国际多中心注册临床试验数据和生物标志物初步分析结果',
            item: [
              {
                date: '2022年11月15日',
                intro: '海报编号：EP08.02-029',
                detail: {
                  第一作者: '宋玉琴',
                  会议: '第64届美国血液学会'
                },
                link: 'https://ashpublications.org/blood/article/140/Supplement%201/6545/492123/Preliminary-Biomarker-Data-from-a-Phase-1-2-Study'
              }
            ]
          }
        ]
      },
      {
        intro: '戈利昔替尼治疗复发难治性外周T细胞淋巴瘤的I/II期临床研究在第25届全国临床肿瘤学大会暨2022年CSCO学术年会予以公布',
        dec: [
          {
            title: '一种高选择性JAK1抑制剂戈利昔替尼治疗复发难治性外周T细胞淋巴瘤的I/II期临床研究',
            item: [
              {
                date: '2022年11月5日-2022年11月12日',
                intro: '论文序号：13782',
                detail: {
                  第一作者: '宋玉琴',
                  会议: '第25届全国临床肿瘤学大会暨2022年CSCO学术年会'
                },
                link: 'http://csco.kydev.net/poster/detail/79'
              }
            ]
          }
        ]
      },
      {
        intro: '戈利昔替尼用于治疗复发难治性外周T细胞淋巴瘤的I/II期临床研究数据获选2022年欧洲血液学协会（EHA）大会口头报告',
        dec: [
          {
            title: '戈利昔替尼，一种高选择性JAK1抑制剂，用于治疗复发难治性外周T细胞淋巴瘤I/II期临床研究',
            item: [
              {
                date: '2022年6月12日',
                intro: '摘要编号：S218',
                detail: {
                  报告人: 'Won-Seog Kim',
                  会议: '2022年欧洲血液学协会',
                  分会场: '侵袭性淋巴瘤-创新药'
                },
                link: 'https://library.ehaweb.org/eha/2022/eha2022-congress/357082/won-seog.kim.a.phase.i.ii.study.of.golidocitinib.a.selective.jak1.inhibitor.in.html?f=menu%3D6%2Abrowseby%3D8%2Asortby%3D2%2Amedia%3D3%2Ace_id%3D2233%2Aot_id%3D26858%2Amarker%3D1751%2Afeatured%3D17676'
              }
            ]
          }
        ]
      },
      {
        intro: '戈利昔替尼用于治疗复发难治性外周T细胞淋巴瘤的I/II期临床研究在2022年美国临床肿瘤学会（ASCO）大会予以公布',
        dec: [
          {
            title: '戈利昔替尼，高选择性JAK1抑制剂，用于治疗复发难治性外周T细胞淋巴瘤I/II期临床研究数据',
            item: [
              {
                date: '2022年6月4日',
                intro: '摘要编号：#7563',
                detail: {
                  第一作者: 'Won Seog Kim',
                  会议: '2022年美国临床肿瘤学会',
                  分会场: '血液系统恶性肿瘤 – 淋巴瘤和慢性淋巴细胞白血病A厅'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/210230'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD4205用于治疗复发难治性外周T细胞淋巴瘤的I/II期临床数据被选为2021年度国际恶性淋巴瘤大会口头报告',
        dec: [
          {
            title: 'JAK1选择性抑制剂DZD4205治疗复发难治性外周T细胞淋巴瘤的I/II期临床研究初步安全性和有效性数据',
            item: [
              {
                date: '2021年6月22日',
                intro: '摘要编号：57 JAK1选择性抑制剂DZD4205治疗复发难治性外周T细胞淋巴瘤的I/II期临床研究初步安全性和有效性数据',
                detail: {
                  报告人: 'Won-Seog Kim教授，首尔（韩国）',
                  分会场8: '外周T/NK细胞淋巴瘤'
                },
                link: 'http://www.dizalpharma.com/pdf/迪哲医药DZD4205于2021年国际恶性淋巴瘤大会口头报告摘要.pdf'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD4205, 一种JAK1选择性抑制剂，治疗复发难治性外周T细胞淋巴瘤',
        dec: [
          {
            title: 'DZD4205文章摘要被选为2020年第62届美国血液学会年会报告',
            item: [
              {
                intro: '一项评估DZD4205（一种JAK1选择性抑制剂）治疗复发难治性外周T细胞淋巴瘤的I/II期临床研究',
                detail: {
                  作者: 'Won-Seog Kim, Dok-Hyun Yoon, MD, PhD, Hyeon-Seok Eom, Youngil Koh, MD, PhD, Jae-Yong Kwak, Won-Sik Lee, Jong-Seok Lee, Ho-Jin Shin, Yuqin Song, MD, PhD, Haiyan Yang, MD, PhD, Mei Wang, Jingrun Li, MD, PhD, Xubin Huang, Xueyuan Deng, Kan Chen, Zhenfan Yang and Jun Zhu',
                  会议: '2020年第62届美国血液学会年会'
                },
                link: 'https://ash.confex.com/ash/2020/webprogram/Paper134650.html'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD4205(AZD4205)，一种高效的、胃肠道吸收好的JAK1选择性抑制剂，用于治疗炎症性肠病（IBD）',
        dec: [
          {
            title: 'DZD4205(AZD4205)文章摘要被选为2019年欧洲克罗恩病和结肠炎组织（ECCO）年会口头报告',
            item: [
              {
                intro: '摘要DOP017  – DZD4205(AZD4205)，一种高效的、胃肠道吸收好的JAK1选择性抑制剂，用于治疗炎症性肠病（IBD）',
                detail: {
                  作者: 'M Wang, T John, L Zhang, L Zhu, Y Xu, K Chen, S Han, J Li, F Wang, C Deceneux, A Behren, Z Yang',
                  会议: '2019年欧洲克罗恩病和结肠炎组织年会'
                },
                link: 'https://www.ecco-ibd.eu/publications/congress-abstract-s/abstracts-2019/item/dop17-azd4205-a-potent-gi-tract-enriched-jak1-selective-inhibitor-for-treatment-of-inflammatory-bowel-disease-ibd.html'
              }
            ]
          }
        ]
      }
    ],
    DZD8586: [
      {
        intro: 'DZD8586治疗BTK依赖性和非依赖性耐药B细胞恶性肿瘤的初步临床研究结果在第17届恶性淋巴瘤国际会议（ICML）予以公布',
        dec: [
          {
            title: 'DZD8586治疗BTK依赖性和非依赖性耐药B细胞恶性肿瘤的初步临床研究结果',
            item: [
              {
                date: '2023年6月14日-6月16日',
                detail: {
                  报告人: '周可树',
                  会议: '第17届恶性淋巴瘤国际会议'
                },
                link: 'https://onlinelibrary.wiley.com/doi/10.1002/hon.3165_655'
              }
            ]
          }
        ]
      }
    ],
    DZD2269: [
      {
        intro: '新型腺苷A2a受体（A2aR）拮抗剂DZD2269的I期研究成果在《Journal of Experimental & Clinical Cancer Research》发表',
        dec: [
          {
            title: 'DZD2269一种高选择性A2aR拮抗剂，可有效阻断高浓度腺苷引起的免疫抑制',
            item: [
              {
                date: '2022年11月9日',
                detail: {
                  通讯作者: '张小林',
                  影响因子: '12.658'
                },
                link: 'https://jeccr.biomedcentral.com/articles/10.1186/s13046-022-02511-1?utm_source=xmol&utm_medium=affiliate&utm_content=meta&utm_campaign=DDCN_1_GL01_metadata'
              }
            ]
          }
        ]
      },
      {
        intro: '新型高选择性腺苷A2a受体（A2aR）拮抗剂DZD2269的临床药代动力学、药效关系研究在2022年美国临床肿瘤学会（ASCO）予以发布',
        dec: [
          {
            title: 'DZD2269-针对解除高浓度腺苷引起的免疫抑制作用的高选择性腺苷A2a受体拮抗剂-之临床药代动力学、药效关系研究',
            item: [
              {
                date: '线上发布',
                intro: '摘要编号：e15106',
                detail: {
                  第一作者: '刘子仪',
                  会议: '2022年美国临床肿瘤学会'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/211837'
              }
            ]
          }
        ]
      }
    ],
    DZD1516: [
      {
        intro: 'DZD1516的临床前和I期临床研究成果在《Breast Cancer Research》上发表',
        dec: [
          {
            title: 'DZD1516-一款可完全穿透血脑屏障的高选择HER2抑制剂的临床前和临床研究',
            item: [
              {
                detail: {
                  第一作者: '张剑'
                },
                link: 'https://breast-cancer-research.biomedcentral.com/articles/10.1186/s13058-023-01679-4'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD1516针对HER2阳性转移性乳腺癌I期临床最新研究结果在2022年圣安东尼奥乳腺癌大会（SABCS）上予以公布',
        dec: [
          {
            title: 'DZD1516-一款口服、高效、可逆且可完全穿透血脑屏障的高选择性HER2酪氨酸激酶抑制剂用于治疗HER2阳性转移乳腺癌的临床数据更新',
            item: [
              {
                date: '2022年12月9日',
                intro: '摘要编号：#P4-01-23',
                detail: {
                  第一作者: '张剑',
                  会议: '2022年圣安东尼奥乳腺癌大会'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=34'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD1516用于治疗HER2阳性晚期乳腺癌的I期临床研究初步数据入选第25届全国临床肿瘤学大会暨2022年CSCO学术年会口头报告',
        dec: [
          {
            title: 'DZD1516，可完全渗透血脑屏障的高选择性HER2酪氨酸激酶抑制剂，治疗HER2阳性晚期乳腺癌的I期临床研究初步数据',
            item: [
              {
                date: '2022年11月5日',
                detail: {
                  汇报人: '张剑',
                  会议: '第25届全国临床肿瘤学大会暨2022年CSCO学术年会',
                  分会场: '创新药物临床研究数据专场1'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=28'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD1516在HER2阳性转移性乳腺癌患者中开展的国际多中心I期临床研究的安全性和药代动力学数据在2022年欧洲肿瘤内科学会（ESMO）年会予以公布',
        dec: [
          {
            title: 'DZD1516，完全穿透血脑屏障的高选择性HER2酪氨酸激酶抑制剂，用于治疗HER2阳性转移性乳腺癌安全性、药代动力学临床研究数据',
            item: [
              {
                date: '2022年9月10日',
                intro: '报告编号：238P',
                detail: {
                  第一作者: '张剑',
                  会议: '2022年欧洲肿瘤内科学会',
                  分会场: '海报展示02'
                },
                link: 'https://oncologypro.esmo.org/meeting-resources/esmo-congress/clinical-safety-and-pharmacokinetics-pk-data-of-dzd1516-an-bbb-penetrant-selective-her2-inhibitor-for-the-treatment-of-her2-positive-metastatic'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD1516用于治疗HER2阳性转移性乳腺癌初步安全性、药代动力学临床研究数据在2022年美国临床肿瘤学会（ASCO）予以公布',
        dec: [
          {
            title: 'DZD1516，完全穿透血脑屏障的高选择性HER2酪氨酸激酶抑制剂，用于治疗HER2阳性转移性乳腺癌初步安全性、药代动力学临床研究数据',
            item: [
              {
                date: '2022年6月6日',
                intro: '摘要编号：#1038',
                detail: {
                  第一作者: '胡夕春',
                  会议: '2022年美国临床肿瘤学会',
                  分会场: '乳腺癌-转移性A厅'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/210411'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD1516用于治疗HER2阳性转移性乳腺癌的临床前数据以及初步安全性、药代动力学临床研究数据在2021年圣安东尼奥乳腺癌大会予以公布',
        dec: [
          {
            title: 'DZD1516(口服、可逆、可渗透血脑屏障的高选择性 HER2酪氨酸激酶抑制剂)用于治疗HER2阳性转移性乳腺癌的临床前数据以及初步安全性、药代动力学临床研究数据',
            item: [
              {
                date: '2021年12月9日',
                intro: '壁报编号：P2-13-43',
                detail: {
                  会议: '2021 San Antonio Breast Cancer Symposium',
                  分会场: '治疗策略：HER2靶向治疗',
                  作者: '张剑，Nicholas McAndrew，胡夕春等'
                },
                link: 'https://www.sabcs.org/Program/Poster-Sessions/Poster-Session-2'
              }
            ]
          }
        ]
      }
    ]
  },
  lung: '肺癌',
  chronic: '慢性',
  kidney: '肾病',
  inflammatory: '炎症性',
  bowel: '肠病',
  anti_virus: '抗病毒',
  anti_virus_project: '抗病毒项目',
  apply: '申请',
  company_name: '迪哲医药',
  tel: '电话',
  fax: '传真',
  email: '电子邮箱',
  return_to_jobs: '返回招聘列表',
  back_to_news: '返回新闻列表',
  we: '我们',
  healthiest_award: '怡安臻选最佳员工健康雇主',
  outstanding_award: '大中华区杰出雇主奖',
  award1_desc: '迪哲医药蝉联“2021亚洲最佳职场（中国大陆区）奖项评选-“最健康雇主奖“',
  award2_desc: '迪哲医药-2020怡安臻选 最佳员工健康雇主之 “最佳心理健康实践奖“',
  award3_desc: '迪哲医药荣膺“2019亚洲最佳职场(中国大陆区)奖项评选之”最健康员工奖“',
  award4_desc: '迪哲医药荣膺“2022HRoot大中华区人力资源管理卓越大奖”之“大中华区杰出雇主奖”',
  asia_best: '亚洲最佳职场',
  health_center: '健康理疗中心',
  sports_team: '活力运动团队',
  eap: '员工援助计划',
  health_well: '各式健康活动',
  location_facilities: '工作地点及设施',

  flexible: {
    name: '灵活的工作安排',
    detail: '迪哲为员工提供灵活的工作安排。'
  },
  activity: {
    name: '员工文化',
    detail: '迪哲为员工组织各类活动，包括员工表彰、团建、家庭日等。'
  },
  // caring: {
  //   name: '全面薪酬',
  //   detail: ['固定薪酬', '丰厚奖金', '福利保障', '认可发展']
  // },
  follow_us: '关注我们',
  latest_news: '最新动态',
  job: {
    intro: ['期待志同道合的有志之士加盟公司。', '迪哲为您提供有竞争力的薪资福利和极佳的职业发展机会。', '如果您有意向应聘以下岗位，请将简历发送至'],
    detail_btn: '职位详情',
    list_name: '职位列表'
  },
  location: {
    name: '地址',
    more: '查看更多',
    detail1: '迪哲医药位于中国上海张江、北京、无锡、成都等地设有办事处，并在张江设有临床职能办公中心，药物化学实验室，试验动物中心。',
    detail2: '张江是全球医药创新新引擎， 这一战略性的地理位置便于我们与相邻的各大学术、科研机构开展合作，旨在寻求现有疾病领域的新突破。迪哲拥有一流的研发设施，覆盖新药研发全生命周期。',
    address: {
      Shanghai: {
        name: '上海',
        addr: '上海市浦东新区亮景路199号, 201203',
        tel: '+86-21-61097800',
        fax: '+86-21-58387361',
        email: 'info@dizalpharma.com'
      },
      Beijing: {
        name: '北京',
        addr: '北京市朝阳区建国路79号华贸中心写字楼2座23层2309室',
        tel: '+86-10-87513588',
        fax: '+86-10-58043622'
      },
      Wuxi: {
        name: '无锡',
        addr: '无锡市新吴区和风路26号汇融商务广场C栋404室'
      },
      Chengdu: {
        name: '成都',
        addr: '成都市锦江区人民南路2段1号仁恒置地广场31层8单元, 610020'
      }
    }
  },
  see_map: '查看地图',
  terms_of_use: {
    name: '使用守则',
    content: [
      // 法律声明
      {
        subtitle: '法律声明',
        intro: [
          {
            dec: '本网站由迪哲医药股份有限公司（以下简称“迪哲医药”）创建并运行维护。任何人进入本网站、阅读任何内容、进行用户注册、从本网站下载任何材料或使用本网站提供的资料，即表示同意遵守下列条款。这些条款构成迪哲医药与您之间的协议。若不同意遵守这些条款，切勿使用本网站。迪哲医药保留未经通知随时更新下列条款的权利，这些更新将同样也约束您。任何时间，任何情况下，迪哲医药均有权拒绝任何用户进入、使用本网站。迪哲医药保留随时更正、修改、更新本声明的权利。',
            addition: []
          }
        ]
      },
      //   版权声明
      {
        subtitle: '版权声明',
        intro: [
          {
            dec: '迪哲医药独立拥有本网站相关网页内所有资料的版权，或与本网站相关网页内的资料提供者共同拥有该网页内资料的版权。未经迪哲医药的明确书面许可，对于本网站上的任何内容，任何人不得对其进行复制或在非迪哲医药所属的服务器上做镜像。本网站所载述的域名、商标、文字、视像及声音内容、图形及图像均受有关商标和著作权的法律保护。未经迪哲医药事先以书面明确的允许，任何企业或个人不得以任何形式复制或传递。任何未经授权使用本网站的行为都将违反《中华人民共和国著作权法》和其他相关法律法规以及有关国际公约的规定。',
            addition: []
          }
        ]
      }
    ]
  },
  privacy_policy: {
    name: '隐私政策',
    content: [
      {
        subtitle: null,
        intro: [
          {
            dec: '本隐私保护声明适用于使用“迪哲医药”网站（以下简称本网站）提供的各种服务的用户。我们尊重、保护用户的个人隐私，并郑重承诺，除非有法律或程序要求，否则未经用户授权我们不会公布与用户个人有关的资料。我们将定期检查隐私保护措施，切实保证用户个人资料隐私保护。',
            addition: []
          },
          {
            dec: '在以下几个例外情形下，将无法保证前述的承诺，而披露用户的相关信息。这些情形包括但不限于：',
            addition: [
              '当用户在本网站的行为违反了《计算机信息网络国际联网安全保护管理办法》、《互联网信息服务管理办法》，或可能损害或妨碍其他网友的权益或导致他人遭受损害，披露用户的个人资料是为了辨识、联络或采取法律行动所必要的行动时。',
              '法律法规所规定的必须披露或公开的个人信息。',
              '当司法机关或其它授权机关依法执行公务，要求网站公开特定个人资料时。'
            ]
          },
          /*{
          dec: "如果你的信息由《通用数据保护条例》（General Data Protection Regulation (GDPR)）管辖,请联络下面的欧洲数据保护官（EU Data Protection Officer (DPO)）：",
          addition: [
            "数据保护官：VeraSafe, LLC",
            "邮箱地址: experts@verasafe.com。",
            "(1)美国的联系方式",
            "地址：22 Essex Way #8203, Essex, VT 05451 USA",
            "电话： +1-617-398-7067",
            "(2)欧洲的联系方式:",
            "地址：Klimentská 46, Prague 1, 11002 Czech Republic",
            "电话： +1-617-398-7067",
          ]
        },*/
          {
            dec: '本网站具有全面的技术保护措施和安全维护机制来保证用户信息的内容，但由于不可抗力或者因计算机病毒感染、黑客攻击等特殊外力侵扰，导致用户信息破坏、泄密并受到损失的，本网站不承担任何法律责任。',
            addition: []
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js